// extracted by mini-css-extract-plugin
export var container = "Modal-module--container--3nXi0";
export var closeBtn = "Modal-module--closeBtn--1FnkF";
export var overflowWrap = "Modal-module--overflowWrap--1igK7";
export var wrapper = "Modal-module--wrapper--iv9qd";
export var portal = "Modal-module--portal--21oz4";
export var open = "Modal-module--open--2RjyE";
export var dimmed = "Modal-module--dimmed--21Ozn";